import React from 'react';
import './OrderHeader.scss';
import { formatDate } from '../../utils/helper';
import { connect } from 'react-redux';

function OrderHeader(props) {
  const {
    view,
    currencyMark,
    order: {
      id,
      createdAt,
      amount: { total, currencyCode = 'INR' },
      isInsuranceFlow,
      insuranceFlowDetails,
    },
    dataLocale: { ORDER_ID, ORDER_DATE, TOTAL_PRICE, CURRENCY_CODE },
    redisCommonData,
  } = props;
  const { INSURANCE_POST_ORDER_CONFIG } = redisCommonData;
  const currencySymbol = currencyCode ? (
    <span>{currencyMark[currencyCode]}</span>
  ) : (
    <span>{currencyMark[CURRENCY_CODE]}</span>
  );

  return (
    <>
      <div
        className={`order-header ${
          view === 'desktop'
            ? 'display-flex padding-t10 padding-b10 padding-l30 padding-r30 margin-t10 margin-b8 fs14'
            : 'mr-t8 mr-b10 fsp14'
        }`}
      >
        <div
          className={`display-flex justify-space-between ${
            view === 'desktop' ? 'flex-basis-40' : ''
          }`}
        >
          <span>
            <span className="text-color_pale_black text-color-grey">{ORDER_ID}: </span>
            <strong className={`${view === 'desktop' ? 'text-color-33' : 'text-color_grey_black'}`}>
              {id}
            </strong>
          </span>
          <span>
            <span className="text-color_pale_black text-color-grey">{ORDER_DATE}: </span>
            <strong className={`${view === 'desktop' ? 'text-color-33' : 'text-color_grey_black'}`}>
              {formatDate(createdAt, 'D MMM')}
            </strong>
          </span>
        </div>
        <div
          className={`order-total ${
            view === 'desktop'
              ? 'flex-basis-60 margin-t0 padding-t0 text-end'
              : 'mr-t12 pd-t10 border-top'
          }`}
        >
          <span>
            <span className={`${view === 'desktop' ? 'text-color-grey' : 'text-color_pale_black'}`}>
              {TOTAL_PRICE}:{' '}
            </span>
            <strong
              className={`${view === 'desktop' ? 'fs16 text-color-33' : 'text-color_grey_black '}`}
            >
              {currencySymbol}
              {total}
            </strong>
          </span>
        </div>
      </div>
      {isInsuranceFlow && (
        <div className={`app-download-info bora-8 ${view === 'desktop' ? 'desktop-view' : ''}`}>
          <div className="info-left">
            <h3>{INSURANCE_POST_ORDER_CONFIG?.title}</h3>
            <p>
              {INSURANCE_POST_ORDER_CONFIG?.description.replace(
                '%s',
                insuranceFlowDetails?.provider || 'insurance' // Replaces %s with API data or fallback
              )}
            </p>
          </div>
          <div className="download-app">
            {view === 'desktop' ? (
              <>
                <img
                  alt={INSURANCE_POST_ORDER_CONFIG?.alt}
                  src={INSURANCE_POST_ORDER_CONFIG?.imgAppStore}
                  title={INSURANCE_POST_ORDER_CONFIG?.alt}
                />
                <img
                  alt={INSURANCE_POST_ORDER_CONFIG?.alt}
                  src={INSURANCE_POST_ORDER_CONFIG?.imgGooglePlay}
                  title={INSURANCE_POST_ORDER_CONFIG?.alt}
                />
              </>
            ) : (
              <a href={INSURANCE_POST_ORDER_CONFIG?.downloadAppLink}>
                <img
                  alt={INSURANCE_POST_ORDER_CONFIG?.alt}
                  src={INSURANCE_POST_ORDER_CONFIG?.imgUrl}
                  title={INSURANCE_POST_ORDER_CONFIG?.alt}
                />
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
}
const mapStateToProps = state => ({
  redisCommonData: state.common.redisCommonData,
});

export default connect(mapStateToProps)(OrderHeader);
